/* eslint-disable */

/* This is auto generated code. Do not edit!!! */

import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
};

export const GraphQLCardExpiryStatus = {
  Expired: 'EXPIRED',
  ExpiringSoon: 'EXPIRING_SOON'
} as const;

export type GraphQLCardExpiryStatus = typeof GraphQLCardExpiryStatus[keyof typeof GraphQLCardExpiryStatus];
export type GraphQLCommitment = {
  __typename?: 'Commitment';
  _sys?: Maybe<GraphQLCommitmentSys>;
  amountDue?: Maybe<Scalars['Float']['output']>;
  commitmentType: GraphQLCommitmentType;
  creditRemaining?: Maybe<Scalars['Float']['output']>;
  dates: GraphQLCommitmentDates;
  dueThisMonthAmount?: Maybe<Scalars['Float']['output']>;
  frequency: Scalars['String']['output'];
  fund?: Maybe<GraphQLCommitmentFund>;
  globalId: Scalars['ID']['output'];
  hasCredit?: Maybe<Scalars['Boolean']['output']>;
  hasDueThisMonth?: Maybe<Scalars['Boolean']['output']>;
  hasMissedPayment?: Maybe<Scalars['Boolean']['output']>;
  internalId: Scalars['String']['output'];
  interventionId?: Maybe<Scalars['String']['output']>;
  isCorrespondent?: Maybe<Scalars['Boolean']['output']>;
  isRecurring: Scalars['Boolean']['output'];
  lastCorrespondenceDate?: Maybe<Scalars['String']['output']>;
  missedPaymentAmount?: Maybe<Scalars['Float']['output']>;
  participant?: Maybe<GraphQLCommitmentParticipant>;
  /** Next payment date in YYYY-MM-DD format (e.g., "2024-01-15") */
  paymentDateNext?: Maybe<Scalars['AWSDate']['output']>;
  paymentFrequency?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  paymentPullDay?: Maybe<Scalars['Int']['output']>;
  rate: Scalars['Float']['output'];
  receiptorId?: Maybe<Scalars['String']['output']>;
  sourceCode: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentDates = {
  __typename?: 'CommitmentDates';
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentFund = {
  __typename?: 'CommitmentFund';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentParticipant = {
  __typename?: 'CommitmentParticipant';
  birthdate?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  globalId?: Maybe<Scalars['String']['output']>;
  localId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  names?: Maybe<GraphQLCommitmentParticipantNames>;
  photoUrl?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentParticipantNames = {
  __typename?: 'CommitmentParticipantNames';
  preferred?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentSys = {
  __typename?: 'CommitmentSys';
  billingType: Scalars['String']['output'];
  delinkType?: Maybe<Scalars['String']['output']>;
  linkType: Scalars['String']['output'];
  program?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  subProgram?: Maybe<Scalars['String']['output']>;
};

export const GraphQLCommitmentType = {
  ChildSponsorship: 'ChildSponsorship',
  Correspondence: 'Correspondence',
  FundCommitment: 'FundCommitment',
  GiftCatalog: 'GiftCatalog',
  GiftCommitment: 'GiftCommitment',
  Intervention: 'Intervention',
  LivingSponsorship: 'LivingSponsorship',
  Na: 'NA'
} as const;

export type GraphQLCommitmentType = typeof GraphQLCommitmentType[keyof typeof GraphQLCommitmentType];
export type GraphQLGivingTotals = {
  __typename?: 'GivingTotals';
  amountDue?: Maybe<Scalars['Float']['output']>;
  amountWaived?: Maybe<Scalars['Float']['output']>;
  annual?: Maybe<Scalars['Float']['output']>;
  monthly?: Maybe<Scalars['Float']['output']>;
  quarterly?: Maybe<Scalars['Float']['output']>;
  semiAnnual?: Maybe<Scalars['Float']['output']>;
  totalCreditRemaining?: Maybe<Scalars['Float']['output']>;
  totalDueThisMonthAmount?: Maybe<Scalars['Float']['output']>;
  totalMissedPaymentAmount?: Maybe<Scalars['Float']['output']>;
};

export type GraphQLPaymentMethodAch = {
  __typename?: 'PaymentMethodAch';
  accountName: Scalars['String']['output'];
  lastFourOfAccountNumber: Scalars['String']['output'];
  routingNumber: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type GraphQLPaymentMethodBillingAddress = {
  __typename?: 'PaymentMethodBillingAddress';
  attention?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type GraphQLPaymentMethodCreditCard = {
  __typename?: 'PaymentMethodCreditCard';
  cardType: Scalars['String']['output'];
  cardholderName: Scalars['String']['output'];
  digitalType?: Maybe<Scalars['String']['output']>;
  expirationDate: Scalars['String']['output'];
  expiryStatus?: Maybe<GraphQLCardExpiryStatus>;
  lastFour: Scalars['String']['output'];
  responseCode?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type GraphQLPledge = {
  __typename?: 'Pledge';
  endDate?: Maybe<Scalars['String']['output']>;
  lastInstallmentAmount?: Maybe<Scalars['Float']['output']>;
  lastInstallmentDate?: Maybe<Scalars['String']['output']>;
  nextInstallmentAmount?: Maybe<Scalars['Float']['output']>;
  nextInstallmentDate?: Maybe<Scalars['String']['output']>;
  outstandingAmount: Scalars['Float']['output'];
  pledgeId: Scalars['String']['output'];
  pledgeName: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalGivenToDate: Scalars['Float']['output'];
  totalPledgeAmount: Scalars['Float']['output'];
};

/**
 * Currently all types live here.
 * Originally the idea was to maintain separate sub-schemas with a custom script to merge them,
 * but until things mature it seemed best to keep it all in one file.
 *
 * TOC
 *
 * = Operations
 * = Scalars
 * = Supporter
 * = Payment & Billing
 * = Commitment
 */
export type GraphQLQuery = {
  __typename?: 'Query';
  supporter?: Maybe<GraphQLSupporter>;
};


/**
 * Currently all types live here.
 * Originally the idea was to maintain separate sub-schemas with a custom script to merge them,
 * but until things mature it seemed best to keep it all in one file.
 *
 * TOC
 *
 * = Operations
 * = Scalars
 * = Supporter
 * = Payment & Billing
 * = Commitment
 */
export type GraphQLQuerySupporterArgs = {
  globalId?: InputMaybe<Scalars['String']['input']>;
};

export type GraphQLSupporter = {
  __typename?: 'Supporter';
  addressDetails: GraphQLSupporterAddress;
  commitments: Array<GraphQLCommitment>;
  correspondenceDeliveryPreference: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  givingTotals?: Maybe<GraphQLGivingTotals>;
  globalId: Scalars['String']['output'];
  internalId: Scalars['String']['output'];
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  paymentMethods: Array<GraphQLSupporterPaymentMethod>;
  pledges: Array<GraphQLPledge>;
  preferredName?: Maybe<Scalars['String']['output']>;
  primaryContactId: Scalars['String']['output'];
  primaryLanguage: Scalars['String']['output'];
  rateChangeDeadline?: Maybe<Scalars['String']['output']>;
  rateChangeResponse?: Maybe<Scalars['String']['output']>;
  rateChangeSegment?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  sourceCode?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  suffix?: Maybe<Scalars['String']['output']>;
  taxReceipts: Array<GraphQLTaxReceipt>;
  type?: Maybe<Scalars['String']['output']>;
  typeLevel2?: Maybe<Scalars['String']['output']>;
  typeLevel3?: Maybe<Scalars['String']['output']>;
  undeliverableEmail?: Maybe<Scalars['Boolean']['output']>;
  undeliverablePhone?: Maybe<Scalars['Boolean']['output']>;
};

export type GraphQLSupporterAddress = {
  __typename?: 'SupporterAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  isUndeliverable: Scalars['Boolean']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type GraphQLSupporterPaymentMethod = {
  __typename?: 'SupporterPaymentMethod';
  accountNickname?: Maybe<Scalars['String']['output']>;
  ach?: Maybe<GraphQLPaymentMethodAch>;
  billingAddress?: Maybe<GraphQLPaymentMethodBillingAddress>;
  creditCard?: Maybe<GraphQLPaymentMethodCreditCard>;
  id?: Maybe<Scalars['String']['output']>;
  isCreatedForReceiptor?: Maybe<Scalars['Boolean']['output']>;
  isSavedForReuse?: Maybe<Scalars['Boolean']['output']>;
  paymentType: Scalars['String']['output'];
  sourceCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GraphQLTaxReceipt = {
  __typename?: 'TaxReceipt';
  url?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type GraphQLResolversTypes = {
  AWSDate: ResolverTypeWrapper<Scalars['AWSDate']['output']>;
  AWSDateTime: ResolverTypeWrapper<Scalars['AWSDateTime']['output']>;
  AWSEmail: ResolverTypeWrapper<Scalars['AWSEmail']['output']>;
  AWSIPAddress: ResolverTypeWrapper<Scalars['AWSIPAddress']['output']>;
  AWSJSON: ResolverTypeWrapper<Scalars['AWSJSON']['output']>;
  AWSPhone: ResolverTypeWrapper<Scalars['AWSPhone']['output']>;
  AWSTime: ResolverTypeWrapper<Scalars['AWSTime']['output']>;
  AWSTimestamp: ResolverTypeWrapper<Scalars['AWSTimestamp']['output']>;
  AWSURL: ResolverTypeWrapper<Scalars['AWSURL']['output']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  CardExpiryStatus: GraphQLCardExpiryStatus;
  Commitment: ResolverTypeWrapper<GraphQLCommitment>;
  CommitmentDates: ResolverTypeWrapper<GraphQLCommitmentDates>;
  CommitmentFund: ResolverTypeWrapper<GraphQLCommitmentFund>;
  CommitmentParticipant: ResolverTypeWrapper<GraphQLCommitmentParticipant>;
  CommitmentParticipantNames: ResolverTypeWrapper<GraphQLCommitmentParticipantNames>;
  CommitmentSys: ResolverTypeWrapper<GraphQLCommitmentSys>;
  CommitmentType: GraphQLCommitmentType;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GivingTotals: ResolverTypeWrapper<GraphQLGivingTotals>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  PaymentMethodAch: ResolverTypeWrapper<GraphQLPaymentMethodAch>;
  PaymentMethodBillingAddress: ResolverTypeWrapper<GraphQLPaymentMethodBillingAddress>;
  PaymentMethodCreditCard: ResolverTypeWrapper<GraphQLPaymentMethodCreditCard>;
  Pledge: ResolverTypeWrapper<GraphQLPledge>;
  Query: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Supporter: ResolverTypeWrapper<GraphQLSupporter>;
  SupporterAddress: ResolverTypeWrapper<GraphQLSupporterAddress>;
  SupporterPaymentMethod: ResolverTypeWrapper<GraphQLSupporterPaymentMethod>;
  TaxReceipt: ResolverTypeWrapper<GraphQLTaxReceipt>;
};

/** Mapping between all available schema types and the resolvers parents */
export type GraphQLResolversParentTypes = {
  AWSDate: Scalars['AWSDate']['output'];
  AWSDateTime: Scalars['AWSDateTime']['output'];
  AWSEmail: Scalars['AWSEmail']['output'];
  AWSIPAddress: Scalars['AWSIPAddress']['output'];
  AWSJSON: Scalars['AWSJSON']['output'];
  AWSPhone: Scalars['AWSPhone']['output'];
  AWSTime: Scalars['AWSTime']['output'];
  AWSTimestamp: Scalars['AWSTimestamp']['output'];
  AWSURL: Scalars['AWSURL']['output'];
  Boolean: Scalars['Boolean']['output'];
  Commitment: GraphQLCommitment;
  CommitmentDates: GraphQLCommitmentDates;
  CommitmentFund: GraphQLCommitmentFund;
  CommitmentParticipant: GraphQLCommitmentParticipant;
  CommitmentParticipantNames: GraphQLCommitmentParticipantNames;
  CommitmentSys: GraphQLCommitmentSys;
  Float: Scalars['Float']['output'];
  GivingTotals: GraphQLGivingTotals;
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  PaymentMethodAch: GraphQLPaymentMethodAch;
  PaymentMethodBillingAddress: GraphQLPaymentMethodBillingAddress;
  PaymentMethodCreditCard: GraphQLPaymentMethodCreditCard;
  Pledge: GraphQLPledge;
  Query: {};
  String: Scalars['String']['output'];
  Supporter: GraphQLSupporter;
  SupporterAddress: GraphQLSupporterAddress;
  SupporterPaymentMethod: GraphQLSupporterPaymentMethod;
  TaxReceipt: GraphQLTaxReceipt;
};

export interface GraphQLAwsDateScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSDate'], any> {
  name: 'AWSDate';
}

export interface GraphQLAwsDateTimeScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSDateTime'], any> {
  name: 'AWSDateTime';
}

export interface GraphQLAwsEmailScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSEmail'], any> {
  name: 'AWSEmail';
}

export interface GraphQLAwsipAddressScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSIPAddress'], any> {
  name: 'AWSIPAddress';
}

export interface GraphQLAwsjsonScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSJSON'], any> {
  name: 'AWSJSON';
}

export interface GraphQLAwsPhoneScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSPhone'], any> {
  name: 'AWSPhone';
}

export interface GraphQLAwsTimeScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSTime'], any> {
  name: 'AWSTime';
}

export interface GraphQLAwsTimestampScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSTimestamp'], any> {
  name: 'AWSTimestamp';
}

export interface GraphQLAwsurlScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSURL'], any> {
  name: 'AWSURL';
}

export type GraphQLCommitmentResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Commitment'] = GraphQLResolversParentTypes['Commitment']> = {
  _sys?: Resolver<Maybe<GraphQLResolversTypes['CommitmentSys']>, ParentType, ContextType>;
  amountDue?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  commitmentType?: Resolver<GraphQLResolversTypes['CommitmentType'], ParentType, ContextType>;
  creditRemaining?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  dates?: Resolver<GraphQLResolversTypes['CommitmentDates'], ParentType, ContextType>;
  dueThisMonthAmount?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  frequency?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  fund?: Resolver<Maybe<GraphQLResolversTypes['CommitmentFund']>, ParentType, ContextType>;
  globalId?: Resolver<GraphQLResolversTypes['ID'], ParentType, ContextType>;
  hasCredit?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  hasDueThisMonth?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  hasMissedPayment?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  internalId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  interventionId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  isCorrespondent?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  isRecurring?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  lastCorrespondenceDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  missedPaymentAmount?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  participant?: Resolver<Maybe<GraphQLResolversTypes['CommitmentParticipant']>, ParentType, ContextType>;
  paymentDateNext?: Resolver<Maybe<GraphQLResolversTypes['AWSDate']>, ParentType, ContextType>;
  paymentFrequency?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  paymentMethodId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  paymentPullDay?: Resolver<Maybe<GraphQLResolversTypes['Int']>, ParentType, ContextType>;
  rate?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
  receiptorId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  sourceCode?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLCommitmentDatesResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentDates'] = GraphQLResolversParentTypes['CommitmentDates']> = {
  end?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLCommitmentFundResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentFund'] = GraphQLResolversParentTypes['CommitmentFund']> = {
  code?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  icon?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLCommitmentParticipantResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentParticipant'] = GraphQLResolversParentTypes['CommitmentParticipant']> = {
  birthdate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  globalId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  localId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  names?: Resolver<Maybe<GraphQLResolversTypes['CommitmentParticipantNames']>, ParentType, ContextType>;
  photoUrl?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLCommitmentParticipantNamesResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentParticipantNames'] = GraphQLResolversParentTypes['CommitmentParticipantNames']> = {
  preferred?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLCommitmentSysResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentSys'] = GraphQLResolversParentTypes['CommitmentSys']> = {
  billingType?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  delinkType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  linkType?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  program?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  recordType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  subProgram?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLGivingTotalsResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['GivingTotals'] = GraphQLResolversParentTypes['GivingTotals']> = {
  amountDue?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  amountWaived?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  annual?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  monthly?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  quarterly?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  semiAnnual?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  totalCreditRemaining?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  totalDueThisMonthAmount?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  totalMissedPaymentAmount?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLPaymentMethodAchResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['PaymentMethodAch'] = GraphQLResolversParentTypes['PaymentMethodAch']> = {
  accountName?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  lastFourOfAccountNumber?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  routingNumber?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLPaymentMethodBillingAddressResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['PaymentMethodBillingAddress'] = GraphQLResolversParentTypes['PaymentMethodBillingAddress']> = {
  attention?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  stateCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLPaymentMethodCreditCardResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['PaymentMethodCreditCard'] = GraphQLResolversParentTypes['PaymentMethodCreditCard']> = {
  cardType?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  cardholderName?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  digitalType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  expirationDate?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  expiryStatus?: Resolver<Maybe<GraphQLResolversTypes['CardExpiryStatus']>, ParentType, ContextType>;
  lastFour?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  responseCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLPledgeResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Pledge'] = GraphQLResolversParentTypes['Pledge']> = {
  endDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  lastInstallmentAmount?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  lastInstallmentDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  nextInstallmentAmount?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  nextInstallmentDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  outstandingAmount?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
  pledgeId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  pledgeName?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  totalGivenToDate?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
  totalPledgeAmount?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLQueryResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Query'] = GraphQLResolversParentTypes['Query']> = {
  supporter?: Resolver<Maybe<GraphQLResolversTypes['Supporter']>, ParentType, ContextType, Partial<GraphQLQuerySupporterArgs>>;
};

export type GraphQLSupporterResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Supporter'] = GraphQLResolversParentTypes['Supporter']> = {
  addressDetails?: Resolver<GraphQLResolversTypes['SupporterAddress'], ParentType, ContextType>;
  commitments?: Resolver<Array<GraphQLResolversTypes['Commitment']>, ParentType, ContextType>;
  correspondenceDeliveryPreference?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  givingTotals?: Resolver<Maybe<GraphQLResolversTypes['GivingTotals']>, ParentType, ContextType>;
  globalId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  internalId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  isGroup?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  mobilePhone?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  paymentMethods?: Resolver<Array<GraphQLResolversTypes['SupporterPaymentMethod']>, ParentType, ContextType>;
  pledges?: Resolver<Array<GraphQLResolversTypes['Pledge']>, ParentType, ContextType>;
  preferredName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  primaryContactId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  primaryLanguage?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  rateChangeDeadline?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  rateChangeResponse?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  rateChangeSegment?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  recordType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  salutation?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  suffix?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  taxReceipts?: Resolver<Array<GraphQLResolversTypes['TaxReceipt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  typeLevel2?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  typeLevel3?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  undeliverableEmail?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  undeliverablePhone?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLSupporterAddressResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterAddress'] = GraphQLResolversParentTypes['SupporterAddress']> = {
  city?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  isUndeliverable?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  postalCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLSupporterPaymentMethodResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterPaymentMethod'] = GraphQLResolversParentTypes['SupporterPaymentMethod']> = {
  accountNickname?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  ach?: Resolver<Maybe<GraphQLResolversTypes['PaymentMethodAch']>, ParentType, ContextType>;
  billingAddress?: Resolver<Maybe<GraphQLResolversTypes['PaymentMethodBillingAddress']>, ParentType, ContextType>;
  creditCard?: Resolver<Maybe<GraphQLResolversTypes['PaymentMethodCreditCard']>, ParentType, ContextType>;
  id?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  isCreatedForReceiptor?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  isSavedForReuse?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  paymentType?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLTaxReceiptResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['TaxReceipt'] = GraphQLResolversParentTypes['TaxReceipt']> = {
  url?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<GraphQLResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLResolvers<ContextType = any> = {
  AWSDate?: GraphQLScalarType;
  AWSDateTime?: GraphQLScalarType;
  AWSEmail?: GraphQLScalarType;
  AWSIPAddress?: GraphQLScalarType;
  AWSJSON?: GraphQLScalarType;
  AWSPhone?: GraphQLScalarType;
  AWSTime?: GraphQLScalarType;
  AWSTimestamp?: GraphQLScalarType;
  AWSURL?: GraphQLScalarType;
  Commitment?: GraphQLCommitmentResolvers<ContextType>;
  CommitmentDates?: GraphQLCommitmentDatesResolvers<ContextType>;
  CommitmentFund?: GraphQLCommitmentFundResolvers<ContextType>;
  CommitmentParticipant?: GraphQLCommitmentParticipantResolvers<ContextType>;
  CommitmentParticipantNames?: GraphQLCommitmentParticipantNamesResolvers<ContextType>;
  CommitmentSys?: GraphQLCommitmentSysResolvers<ContextType>;
  GivingTotals?: GraphQLGivingTotalsResolvers<ContextType>;
  PaymentMethodAch?: GraphQLPaymentMethodAchResolvers<ContextType>;
  PaymentMethodBillingAddress?: GraphQLPaymentMethodBillingAddressResolvers<ContextType>;
  PaymentMethodCreditCard?: GraphQLPaymentMethodCreditCardResolvers<ContextType>;
  Pledge?: GraphQLPledgeResolvers<ContextType>;
  Query?: GraphQLQueryResolvers<ContextType>;
  Supporter?: GraphQLSupporterResolvers<ContextType>;
  SupporterAddress?: GraphQLSupporterAddressResolvers<ContextType>;
  SupporterPaymentMethod?: GraphQLSupporterPaymentMethodResolvers<ContextType>;
  TaxReceipt?: GraphQLTaxReceiptResolvers<ContextType>;
};

